import { Table } from "@theorgchartdev/storybook";
import { useEffect, useState } from "react";
import ReportLabel from "@/appComponents/Blocks/Modals/ReportExplorer/ReportLabel";
import { GetWSMgr } from "@/Utils/StateLib";
import { PLACEHOLDER_TABLE_VALUE, TABLE_SELECTED_ROW_STYLE } from "@/Utils/Constants";
import { appstr } from "@coreapp/utils/appstr";

export const ReportsTable = ({
  reports,
  selectedReport,
  handleReportClick,
  handleReportAction,
  handleRename,
  chartIdFilter = [],
  inputFilterKey = "",
  ...props
}) => {
  const [reportData, setReportData] = useState({ data: [] });
  const RebuildReportData = () => {
    let newTableData = {
      data: BuildReportTableData()
    };
    setReportData(newTableData);
  };
  const wsMgr = GetWSMgr();
  const userInfo = wsMgr.GetUserInfo();
  const userID = userInfo.GetUserName();

  const BuildReportTableData = () => {
    let filteredReports = reports;
    if (chartIdFilter?.length > 0) {
      filteredReports = filteredReports.filter(report => chartIdFilter.includes(report.chartID));
    }
    if (inputFilterKey.length > 0) {
      filteredReports = filteredReports.filter(
        item => item?.name.toLowerCase().lastIndexOf(inputFilterKey.toLowerCase()) !== -1
      );
    }
    return [...filteredReports].filter(reports => {
      return reports.owner == userID;
    });
  };

  useEffect(() => {
    RebuildReportData();
  }, [reports, chartIdFilter, inputFilterKey]);

  const dateColumnOptions = {
    getValue: (data, fieldName) => {
      return new Date().convertUTCDateToLocalDateString(data[fieldName]);
    },
    getSortValue: value => {
      return value.slice(0, -4);
    }
  };

  const ownerColumnOptions = {
    getValue: (data, fieldName) => {
      let owner = data[fieldName];
      let users = data["users"];
      for (var user of users) {
        if (user["name"] === owner) return user["displayName"];
      }
      return owner;
    }
  };

  const gridOptions = {
    placeHolder: PLACEHOLDER_TABLE_VALUE,
    getRowStyle: (data, _rowIndex, isHovered) => {
      if (data.ID === selectedReport?.ID) {
        return TABLE_SELECTED_ROW_STYLE;
      } else if (isHovered) {
        return { background: "#ececed", cursor: "pointer" };
      }
    },
    onRowClick: (event, data) => handleReportClick(event, data)
  };

  const ReportLabelComponent = ({ rowState }) => {
    const reportData = rowState?.data;
    return (
      <ReportLabel
        reportID={reportData?.ID}
        reportName={reportData?.name}
        isSelected={selectedReport?.ID === reportData?.ID}
        onRename={handleRename}
        handleReportAction={handleReportAction}
        selectedReport={selectedReport}
        dataTestId={"report-explorer-label-" + reportData?.name}
      />
    );
  };

  const columns = [
    {
      field: "name",
      headerName: appstr("Report name"),
      type: "cellRenderer",
      columnWidth: "fifty",
      CellRenderer: ReportLabelComponent
    },
    {
      field: "createDate",
      headerName: appstr("Created date"),
      type: "defaultCol",
      columnOptions: dateColumnOptions
    },
    {
      field: "owner",
      headerName: appstr("Report owner"),
      columnOptions: ownerColumnOptions
    },
    {
      field: "runDate",
      headerName: appstr("Last run"),
      type: "defaultCol",
      columnOptions: dateColumnOptions
    }
  ];

  return (
    <Table
      tableLayout={"fixed"}
      gridOptions={gridOptions}
      columns={columns}
      data={reportData.data}
      showHeader={true}
      sortEnabled={true}
      containerPadding
      {...props?.tableProps}
    />
  );
};
